import GRID_TAXONOMY_DEFS from './grid_taxonomy_defs.json';

export const GRID_TAXONOMY_FILTER_TYPE_CHECKBOX = 'checkbox';
export const GRID_TAXONOMY_FILTER_TYPE_RADIO = 'radio';
export const GRID_TAXONOMY_FILTER_TYPE_DROPDOWN = 'dropdown';

export const GRID_TAXONOMY_FILTER_LOGICAL_OPERATOR_OR = 'or';
export const GRID_TAXONOMY_FILTER_LOGICAL_OPERATOR_AND = 'and';

export const VALID_GRID_TAXONOMY_FILTER_TYPES = GRID_TAXONOMY_DEFS['grid_taxonomy_filter_types'];
export const VALID_GRID_TAXONOMY_FILTER_LOGICAL_OPERATORS = GRID_TAXONOMY_DEFS['grid_taxonomy_filter_logical_operators'];

export const VALID_GRID_TAXONOMY_KEYS = GRID_TAXONOMY_DEFS['grid_taxonomy_keys'];
export const VALID_GRID_TAXONOMY_CATEGORY_KEYS = GRID_TAXONOMY_DEFS['grid_taxonomy_category_keys'];
export const VALID_GRID_TAXONOMY_FILTER_META_KEYS = GRID_TAXONOMY_DEFS['grid_filter_meta_keys'];
export const VALID_GRID_TAXONOMY_TAG_KEYS = GRID_TAXONOMY_DEFS['grid_taxonomy_tag_keys'];

export const DEFAULT_GRID_TAXONOMY = GRID_TAXONOMY_DEFS['default_grid_taxonomy'];
export const DEFAULT_TILE_TAXONOMY = GRID_TAXONOMY_DEFS['default_tile_taxonomy'];
